import useStore from "../../store/useStore";
import * as Switch from "@radix-ui/react-switch";

export function MapButtons() {
  const { showOffBtnMap, setShowOffBtnMap } = useStore((state) => state);

  return (
    <div className="flex flex-col p-4 gap-4 absolute bottom-4 left-4 z-[1000]">
      <div className="flex items-center gap-1">
        <Switch.Root
          className="w-[42px] h-[25px] 
          bg-gray-300/40 rounded-full
          data-[state=checked]:bg-green-500 
          cursor-default"
          id="markers-switch"
          checked={showOffBtnMap.polylineAllPings}
          onCheckedChange={() => setShowOffBtnMap("polylineAllPings")}
        >
          <Switch.Thumb className="block w-[21px] h-[21px] bg-white rounded-full shadow-[0_2px_2px] shadow-blackA7 transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[19px]" />
        </Switch.Root>
        <label
          className="text-[15px] leading-none pr-[15px] text-gray-300"
          htmlFor="markers-switch"
        >
          Todo trajeto
        </label>
      </div>
      <div className="flex items-center gap-1">
        <Switch.Root
          className="w-[42px] h-[25px] 
          bg-gray-300/40 rounded-full
          data-[state=checked]:bg-green-500 
          cursor-default"
          checked={showOffBtnMap.polylineInsideClockIns}
          onCheckedChange={() => setShowOffBtnMap("polylineInsideClockIns")}
        >
          <Switch.Thumb className="block w-[21px] h-[21px] bg-white rounded-full shadow-[0_2px_2px] shadow-blackA7 transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[19px]" />
        </Switch.Root>
        <label
          className="text-[15px] leading-none pr-[15px] text-gray-300"
          htmlFor="trajectory-switch"
        >
          Trajeto dentro batida ponto
        </label>
      </div>

      <div className="flex items-center gap-1">
        <Switch.Root
          className="w-[42px] h-[25px] 
          bg-gray-300/40 rounded-full
          data-[state=checked]:bg-green-500 
          cursor-default"
          id="markers-switch"
          checked={showOffBtnMap.polylineOutsideClockIns}
          onCheckedChange={() => setShowOffBtnMap("polylineOutsideClockIns")}
        >
          <Switch.Thumb className="block w-[21px] h-[21px] bg-white rounded-full shadow-[0_2px_2px] shadow-blackA7 transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[19px]" />
        </Switch.Root>
        <label
          className="text-[15px] leading-none pr-[15px] text-gray-300"
          htmlFor="markers-switch"
        >
          Trajeto fora batida de ponto
        </label>
      </div>

      <div className="flex items-center gap-1">
        <Switch.Root
          className="w-[42px] h-[25px] 
          bg-gray-300/40 rounded-full
          data-[state=checked]:bg-green-500 
          cursor-default"
          id="markers-switch"
          checked={showOffBtnMap.marker}
          onCheckedChange={() => setShowOffBtnMap("marker")}
        >
          <Switch.Thumb className="block w-[21px] h-[21px] bg-white rounded-full shadow-[0_2px_2px] shadow-blackA7 transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[19px]" />
        </Switch.Root>
        <label
          className="text-[15px] leading-none pr-[15px] text-gray-300"
          htmlFor="markers-switch"
        >
          Marcadores
        </label>
      </div>

      <div className="flex items-center gap-1">
        <Switch.Root
          className="w-[42px] h-[25px] 
          bg-gray-300/40 rounded-full
          data-[state=checked]:bg-green-500 
          cursor-default"
          id="stops-switch"
          checked={showOffBtnMap.stopPoints}
          onCheckedChange={() => setShowOffBtnMap("stopPoints")}
        >
          <Switch.Thumb className="block w-[21px] h-[21px] bg-white rounded-full shadow-[0_2px_2px] shadow-blackA7 transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[19px]" />
        </Switch.Root>
        <label
          className="text-[15px] leading-none pr-[15px] text-gray-300"
          htmlFor="stops-switch"
        >
          Paradas
        </label>
      </div>
      <div className="flex items-center gap-1">
        <Switch.Root
          className="w-[42px] h-[25px] 
          bg-gray-300/40 rounded-full
          data-[state=checked]:bg-green-500 
          cursor-default"
          id="markers-switch"
          checked={showOffBtnMap.branches}
          onCheckedChange={() => setShowOffBtnMap("branches")}
        >
          <Switch.Thumb className="block w-[21px] h-[21px] bg-white rounded-full shadow-[0_2px_2px] shadow-blackA7 transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[19px]" />
        </Switch.Root>
        <label
          className="text-[15px] leading-none pr-[15px] text-gray-300"
          htmlFor="markers-switch"
        >
          Filiais
        </label>
      </div>
    </div>
  );
}
